import React from "react";
import { cls } from "@wss/cls";
import { Ratings, RatingsProps } from "@clarkinc/zest-design-system/ui";

interface Props extends Omit<RatingsProps, "size" | "rating"> {
  rating: number;
  size?: keyof typeof sizes;
}

const sizes = {
  small: "xsmall",
  base: "small",
  large: "medium",
  extraLarge: "large",
} as const;

const Stars = ({
  rating,
  size = "base",
  className,
  ...ratingsProps
}: Props) => (
  <>
    {!!rating && rating > 0 ? (
      <Ratings
        rating={rating}
        size={sizes[size]}
        theme="wss"
        data-testid="brand-rating"
        className={cls("inline-flex align-middle mt-px", className)}
        {...ratingsProps}
      />
    ) : null}
  </>
);

export default Stars;
